/**
 * Health Tool
 *
 * At-a-glance status of every system we depend on, from three sources that
 * answer three different questions: the nightly test suite (does it work?),
 * external uptime monitoring (is it up right now?), and this project's own
 * signals (is the backup healthy, are the feeders fresh?).
 *
 * A heartbeat rather than a test tube deliberately — this is an operational
 * health board, not a testing beta.
 */
import { FaHeartbeat } from "react-icons/fa";
import { BaseTool } from "../BaseTool";

export class HealthTool extends BaseTool {
  constructor() {
    super();

    this.id = "health";
    this.name = "System Health";
    this.description =
      "Live status of every service, integration and check we depend on";
    this.icon = FaHeartbeat;
    this.color = "#be123c"; // rose — reads as vital signs, not "danger"
    // Identity stays rose (the heart in the sidebar, the dashboard tile, the
    // page-header icon). CONTROLS go neutral: this board uses red and amber to
    // MEAN something, and a rose button beside a red failure competes with it.
    this.controlColor = "neutral";

    this.path = "/dashboard/tools/health";

    // Owns no collections: it READS the test suite's data in clozesureiodev
    // and this project's own health signals. Nothing here to back up.
    this.collections = [];

    this.requiresAdmin = true;
    // Admin-only (it exposes cost and infrastructure detail), but it belongs in
    // the working nav rather than under System: this is the board you reach for
    // WHEN SOMETHING IS WRONG, and a page you have to remember the location of
    // is a page nobody checks. Permission unchanged — see DashboardSidebar.
    this.mainNav = true;

    this.summaryConfig = { enabled: false };
  }

  async getSummaryData() {
    return { success: true, data: {}, lastUpdated: new Date() };
  }
}
